import * as ActionTypes from './actionTypes';
import * as MessageActions from '../../common/messageBox/actions/actions';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const fetchAdvisorManagementList = (dealerId) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/vehicles/advisor?dealerId=${dealerId}`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_ADVISOR_MANAGEMENT_LIST,
        ActionTypes.FETCHED_ADVISOR_MANAGEMENT_LIST,
        [
          ActionTypes.FETCHED_ADVISOR_MANAGEMENT_LIST_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};

export const fetchAdvisorManagementInfo = (code) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/vehicles/advisor?code=${code}`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_ADVISOR_MANAGEMENT_INFO,
        ActionTypes.FETCHED_ADVISOR_MANAGEMENT_INFO,
        [
          ActionTypes.FETCHED_ADVISOR_MANAGEMENT_INFO_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};

export const addAdvisorManagement =
  (data = {}) =>
    (dispatch) => {
      return dispatch(
        apiActionCreator({
          'endpoint': '/vehicles/advisor',
          'authenticated': true,
          'types': [
            ActionTypes.ADDING_ADVISOR_MANAGEMENT_INFO,
            [
              ActionTypes.ADDED_ADVISOR_MANAGEMENT_INFO,
              MessageActions.addMessageBoxInfo(
                'Asesor creado satisfactoriamente'
              ),
            ],
            [
              ActionTypes.ADDED_ADVISOR_MANAGEMENT_INFO_FAILED,
              (error) => buildErrorMessage(error),
            ],
          ],
          'microservice': 'part',
          'method': 'POST',
          'contentType': 'application/json',
          'data': data,
        })
      );
    };

export const updateAdvisorManagement =
  (code, dealerId, data = {}) =>
    (dispatch) => {
      return dispatch(
        apiActionCreator({
          'endpoint': `/vehicles/advisor/${code}?dealerId=${dealerId}`,
          'authenticated': true,
          'types': [
            ActionTypes.UPDATING_ADVISOR_MANAGEMENT_INFO,
            [
              ActionTypes.UPDATED_ADVISOR_MANAGEMENT_INFO,
              MessageActions.addMessageBoxInfo(
                'Código actualizado satisfactoriamente'
              ),
            ],
            [
              ActionTypes.UPDATED_ADVISOR_MANAGEMENT_INFO_FAILED,
              (error) => buildErrorMessage(error),
            ],
          ],
          'microservice': 'part',
          'method': 'PUT',
          'contentType': 'application/json',
          'data': data,
        })
      );
    };

export const deleteAdvisorManagement =
  (code, dealerId) =>
    (dispatch) => {
      return dispatch(
        apiActionCreator({
          'endpoint': `/vehicles/advisor/${code}?dealerId=${dealerId}`,
          'authenticated': true,
          'types': [
            ActionTypes.DELETING_ADVISOR_MANAGEMENT_INFO,
            [
              ActionTypes.DELETED_ADVISOR_MANAGEMENT_INFO,
              MessageActions.addMessageBoxInfo(
                'Registro eliminado satisfactoriamente'
              ),
            ],
            [
              ActionTypes.DELETED_ADVISOR_MANAGEMENT_INFO_FAILED,
              (error) => buildErrorMessage(error),
            ],
          ],
          'microservice': 'part',
          'method': 'DELETE',
        })
      );
    };

export const clearAdvisorManagement = () => ({
  'type': ActionTypes.CLEAR_ADVISOR_MANAGEMENT_INFO,
});

export const setAdvisorValue = (name, value) => ({
  'type': ActionTypes.SET_ADVISOR_INFO_FORM,
  'payload': {name, value},
});
